import Dropdown from './dropdown'
import { uuid } from './utils/helpers';
import Prop from './utils/prop'

export default class Button {
  constructor() {
      this.initialize();
  }

  initialize() {
    const self = this;
    let buttons;
    buttons = document.querySelectorAll(".sd-btn__name");
    if (buttons.length) {
      buttons.forEach(btn => {
        btn.addEventListener("click", (e) => {
            self.run(e.target.closest(".sd-btn"));
        });
      });
    }
    buttons = document.querySelectorAll(".sd-btn__icon");
    if (buttons.length) {
      buttons.forEach(btn => {
        btn.addEventListener("click", (e) => {
            self.run(e.target.closest(".sd-btn"));
        });
      });
    }
    buttons = document.querySelectorAll(".sd-btn__edit");
    if (buttons.length) {
      buttons.forEach(btn => {
        btn.addEventListener("click", (e) => {
            self.run(e.target.closest(".sd-btn"));
        });
      });
    }
    buttons = document.querySelectorAll(".sd-btn__expander");
    if (buttons.length) {
      buttons.forEach(btn => {
        btn.addEventListener("click", (e) => {
            self.openDropdown(e.target.closest(".sd-btn"));
        });
      });
    }
    buttons = document.querySelectorAll(".mini-action");
    if (buttons.length) {
      buttons.forEach(btn => {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          self.run(btn);
        });
      });
    }

  }

  runAction(el, item) {
    const config = item.config;
    switch (item.name) {
      case "callback":
        const prop = new Prop();
        const fn = prop.get(window, config.callback);

        if (typeof fn === "function") {
          fn.call(null, config);
        } else {
          console.error(
            '[sd-btn] Function "' + config.callback + '" not exists.'
          );
        }
        break;
      case "modal":
        top.loadAction(
          config.url,
          config.name,
          config.icon,
          config.displayType,
          config.modalClass || "mini",
        );
        break;
      case "redirect":
        if (config.newTab || config.new_tab) {
          this.openNewTab(config.url);
        } else {
          window.location = config.url;
        }
        break;
      default:
        console.error("[sd-btn] Unsupported action.", item);
        break;
    }
  }

  getData(el) {
    const dataEl = el.querySelector("script[sd-btn-data]");
    if (!dataEl) {
      return;
    }

    let data;
    try {
      data = JSON.parse(dataEl.innerHTML);
      data.items.forEach((item) => {
        // Dropdown class requires "id" property for data items.
        // We don't need them so they can be random values.
        item.id = uuid();
      });
      return data;
    } catch (e) {
      console.error("[sd-btn] Can not parse data.", dataEl.innerHTML);
      throw e;
    }
  }

  run(el) {
    const data = this.getData(el);

    if (data === undefined) {
      if (el.classList.contains('mini-action')) {
        const { name, type, icon, display, modalClass } = el.dataset;
        let route = el.href;
        route = this.addParam(route, 'action', 1);

        top.loadAction(route, name, icon, display, modalClass);
      }
      return;
    }

    if (data.action.name !== "open-dropdown") {
      this.runAction(el, data.action);
    } else {
      this.openDropdown(el);
    }
  }

  openDropdown(el) {
    const data = this.getData(el);
    if (
      el.classList.contains("is--dropdown") &&
      data.items &&
      data.items.length &&
      !el._sdDropdown
    ) {
      const dropdown = new Dropdown(el, {
        data() {
          return data.items || [];
        },
        renderSelectedItem: null,
        position: "left",
        renderListItem: `
                <div sd-dd-value="<%= item.id %>" class="sd-btn__item d-flex align-items-center pointer">
                    <% if (item.icon) { %>
                      <i class="<%= item.icon %> pe-3"></i>
                    <% } %>
                    <span class="sd-btn__item__name"><%= item.name %></span>
                </div>
              `,
      });
      const self = this;
      dropdown.on("valueChange", ({ value }) => {
        if (value.action) {
          self.runAction(el, value.action);
        }
      });
      el._sdDropdown = dropdown;
    }

    el._sdDropdown.open();
  }

  /**
 * Add a URL parameter
 * @param {string} url
 * @param {string} param the key to set
 * @param {string} value
 */
  addParam = function(url, param, value) {
    const a = document.createElement('a');
    param += (value ? "=" + value : "");
    a.href = url;
    a.search += (a.search ? "&" : "") + param;
    return a.href;
  }

  /**
 * Opens new tab with provided url.
 * @param {String} url
 */
  openNewTab(url) {
    Object.assign(document.createElement('a'), {
      target: '_blank',
      href: url,
      rel: "noopener noreferrer"
    }).click();
  }
}
